import * as http from './base-api'
import * as querystring from 'querystring'


/**
 * 약관 상세 검색
 *
 * @param params
 * @returns {*}
 */

export const findTerms = (id) => {
    return http.get(`/cms/term/${id}`)
}

/**
 * 약관 정보 수정
 *
 * @param data
 * @param id
 * @returns {*}
 */
export const modifyTerms = (data, id) => {
    return http.put(`/cms/term/${id}`, data)
}


/**
 * 약관 조회
 *
 * @param params
 * @returns {*}
 */
export const retrieveTerms = (params) => {
    return http.get(`/cms/term`)
    // return http.demoGet(`/contents_01.json?${querystring.stringify(params)}`)
}
